import { Modal, Box, Typography, Button } from "@mui/material";

export default function ErrorModal({ open, onClose, title, message }) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: "absolute", top: "50%", left: "50%",
        transform: "translate(-50%, -50%)",
        width: "80%", maxWidth: 450, bgcolor: "background.paper",
        p: 4, boxShadow: 24, borderRadius: 2
      }}>
        <Typography variant="h6">{title}</Typography>
        <Typography sx={{ mt: 1, fontSize: "0.95rem" }}>{message}</Typography>
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Button variant="contained" onClick={onClose}>OK</Button>
        </Box>
      </Box>
    </Modal>
  );
}
